import { useState, useEffect } from 'react'
import { Modal } from 'antd'
import styled from 'styled-components'
import WizrButton from './WizrButton'
import WizrText from './WizrText'
import { SESSION_EXPIRED_EVENT } from '../utils/tokenRefresh'
import { buildAuthUrl } from '../utils'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  text-align: center;
`

const SessionExpiredModal = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handler = () => setVisible(true)
    window.addEventListener(SESSION_EXPIRED_EVENT, handler)
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler)
  }, [])

  const handleLogin = async () => {
    window.location.href = await buildAuthUrl()
  }

  return (
    <Modal open={visible} closable={false} footer={null} centered width={400}>
      <ModalContent>
        <WizrText type='h6'>Session Expired</WizrText>
        <WizrText type='body2'>Your session has expired. Please log in again to continue.</WizrText>
        <WizrButton text='Login' onClick={handleLogin} />
      </ModalContent>
    </Modal>
  )
}

export default SessionExpiredModal
